import { useId } from "react";
export function Animal({
  type = "otter",
  size = 100,
  className = "",
}: {
  type?: string;
  size?: number;
  className?: string;
}) {
  if (type === "bird")
    return (
      <svg
        className={`animal ${className}`}
        width={size}
        height={size}
        viewBox="0 0 120 120"
        role="img"
        aria-label="小鸟啾啾"
      >
        <ellipse cx="61" cy="109" rx="32" ry="6" fill="#274e3d" opacity=".09" />
        <path
          d="M50 97v12m21-12v12"
          stroke="#b18d55"
          strokeWidth="5"
          strokeLinecap="round"
        />
        <ellipse cx="60" cy="70" rx="36" ry="36" fill="#e7ba65" />
        <ellipse cx="62" cy="79" rx="25" ry="25" fill="#fcf0ca" />
        <path
          d="M57 36q-9-22-19-19q7 21 19 19q4-29 20-23q-4 19-20 23"
          fill="#d8a553"
        />
        <path d="M26 64q-21 4-13 25q16 6 26-4" fill="#d3a052" />
        <path d="M93 65q17 2 14 21q-17 9-27-1" fill="#d3a052" />
        <circle cx="45" cy="61" r="3.5" fill="#4d5039" />
        <circle cx="77" cy="61" r="3.5" fill="#4d5039" />
        <path d="M52 69h17l-9 10Z" fill="#c98656" />
        <ellipse cx="34" cy="71" rx="7" ry="4" fill="#d99b72" />
        <ellipse cx="86" cy="71" rx="7" ry="4" fill="#d99b72" />
        <path d="M38 90h46v16H38Z" fill="#a3b69b" />
        <path
          d="m38 90 23 10 23-10"
          fill="none"
          stroke="#edf0d4"
          strokeWidth="2"
        />
      </svg>
    );
  if (type === "turtle")
    return (
      <svg
        className={`animal ${className}`}
        width={size}
        height={size}
        viewBox="0 0 120 120"
        role="img"
        aria-label="小龟慢慢"
      >
        <ellipse cx="59" cy="108" rx="43" ry="6" fill="#274e3d" opacity=".09" />
        <ellipse cx="29" cy="95" rx="14" ry="11" fill="#a9bd8a" />
        <ellipse cx="91" cy="96" rx="14" ry="11" fill="#a9bd8a" />
        <ellipse cx="60" cy="85" rx="38" ry="25" fill="#79986f" />
        <path
          d="m46 66 26 0 11 20-16 16-23-5-8-17Z"
          fill="#96ad7b"
          stroke="#607f5a"
          strokeWidth="3"
        />
        <ellipse cx="59" cy="48" rx="29" ry="26" fill="#b8c896" />
        <circle cx="48" cy="46" r="3.5" fill="#435e3c" />
        <circle cx="72" cy="46" r="3.5" fill="#435e3c" />
        <path
          d="m53 58q7 8 14 0"
          stroke="#627b4d"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
        />
        <ellipse cx="38" cy="55" rx="6" ry="3" fill="#d5b494" />
        <ellipse cx="82" cy="55" rx="6" ry="3" fill="#d5b494" />
        <path d="M39 30q20-26 42 0" fill="#cfac6e" />
        <path
          d="M34 31h52"
          stroke="#ae8a50"
          strokeWidth="5"
          strokeLinecap="round"
        />
      </svg>
    );
  const colors: Record<string, string> = {
    otter: "#a67d5d",
    rabbit: "#f1dcc4",
    panda: "#faf8ed",
    bear: "#ba8d62",
    bird: "#eeb449",
    fox: "#e7935e",
    turtle: "#80aa87",
  };
  const c = colors[type] || colors.otter;
  return (
    <svg
      className={`animal ${className}`}
      width={size}
      height={size}
      viewBox="0 0 120 120"
      role="img"
      aria-label={
        {
          otter: "小海獭泡泡",
          rabbit: "小兔米米",
          panda: "熊猫团团",
          bear: "小熊阿布",
          bird: "小鸟啾啾",
          fox: "小狐小栗",
          turtle: "小龟慢慢",
        }[type] || "小伙伴"
      }
    >
      <ellipse cx="61" cy="110" rx="36" ry="6" fill="#274e3d" opacity=".09" />
      {type === "rabbit" ? (
        <>
          <ellipse
            cx="40"
            cy="27"
            rx="11"
            ry="26"
            fill={c}
            transform="rotate(-12 40 27)"
          />
          <ellipse
            cx="79"
            cy="26"
            rx="11"
            ry="25"
            fill={c}
            transform="rotate(12 79 26)"
          />
          <ellipse cx="40" cy="27" rx="5" ry="19" fill="#eeb6a8" />
          <ellipse cx="79" cy="27" rx="5" ry="18" fill="#eeb6a8" />
        </>
      ) : (
        <>
          <circle
            cx="31"
            cy="37"
            r="13"
            fill={type === "panda" ? "#435047" : c}
          />
          <circle
            cx="90"
            cy="37"
            r="13"
            fill={type === "panda" ? "#435047" : c}
          />
          <circle cx="31" cy="37" r="7" fill="#dcb29c" />
          <circle cx="90" cy="37" r="7" fill="#dcb29c" />
        </>
      )}
      <ellipse cx="61" cy="88" rx="29" ry="27" fill={c} />
      <ellipse cx="61" cy="91" rx="20" ry="22" fill="#f5e8d0" />
      <ellipse cx="60" cy="58" rx="40" ry="33" fill={c} />
      <path
        d="M29 58 Q36 43 51 57 Q60 62 69 57 Q84 43 92 60 Q94 85 61 88 Q27 85 29 58"
        fill="#f8eedb"
      />
      {type === "panda" && (
        <>
          <ellipse
            cx="43"
            cy="59"
            rx="11"
            ry="13"
            fill="#435047"
            transform="rotate(22 43 59)"
          />
          <ellipse
            cx="78"
            cy="59"
            rx="11"
            ry="13"
            fill="#435047"
            transform="rotate(-22 78 59)"
          />
        </>
      )}
      <ellipse cx="44" cy="60" rx="3.3" ry="4.2" fill="#343f35" />
      <ellipse cx="77" cy="60" rx="3.3" ry="4.2" fill="#343f35" />
      <circle cx="45" cy="59" r="1" fill="white" />
      <circle cx="78" cy="59" r="1" fill="white" />
      <ellipse cx="34" cy="70" rx="7" ry="4" fill="#e6a392" opacity=".7" />
      <ellipse cx="87" cy="70" rx="7" ry="4" fill="#e6a392" opacity=".7" />
      <path d="M56 68 Q61 65 66 68 L61 73 Z" fill="#514437" />
      <path
        d="M61 73 Q57 81 52 75 M61 73 Q65 81 70 75"
        stroke="#514437"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M34 92 Q25 83 26 75 M87 92 Q100 83 99 72"
        stroke={c}
        strokeWidth="13"
        fill="none"
        strokeLinecap="round"
      />
      <ellipse cx="42" cy="108" rx="12" ry="6" fill={c} />
      <ellipse cx="80" cy="108" rx="12" ry="6" fill={c} />
      {type === "otter" && (
        <>
          <path d="M45 90 Q61 79 77 90 L69 103 H53 Z" fill="#d89377" />
          <path
            d="M61 86 V101 M54 88 L57 100 M68 88 L65 100"
            stroke="#edc2a1"
            strokeWidth="2"
          />
        </>
      )}
      {type === "rabbit" && (
        <path d="M44 91 Q61 98 79 90 L75 108 H48 Z" fill="#83a99a" />
      )}
    </svg>
  );
}
export function Building({
  kind = 0,
  color = "coral",
  x = 0,
  y = 0,
  scale = 1,
}: {
  kind?: number;
  color?: string;
  x?: number;
  y?: number;
  scale?: number;
}) {
  const roof =
    color === "sage" ? "#709788" : color === "sun" ? "#e6b452" : "#db8d70";
  return (
    <g transform={`translate(${x} ${y}) scale(${scale})`}>
      <ellipse cx="0" cy="36" rx="53" ry="13" fill="#607b59" opacity=".15" />
      {kind === 1 ? (
        <>
          <ellipse cy="20" rx="50" ry="23" fill="#abbb78" />
          {[-30, -10, 12, 33].map((v, i) => (
            <g key={v} transform={`translate(${v} ${i % 2 ? 8 : 24})`}>
              <path
                d="M0 5 V-17 M0-5 Q-15-15-15-4 Q-7 1 0-5"
                stroke="#699264"
                strokeWidth="3"
                fill="#699264"
              />
              <circle cy="-20" r="8" fill={i % 2 ? "#f0ce68" : "#e79486"} />
              <circle cy="-20" r="3" fill="#f9ead0" />
            </g>
          ))}
        </>
      ) : kind === 2 ? (
        <>
          <path d="M-47 22 H47 V40 H-47Z" fill="#b28b62" />
          {[-32, -15, 2, 19, 36].map((v) => (
            <path key={v} d={`M${v} 23 V38`} stroke="#886c51" strokeWidth="2" />
          ))}
          <path d="M-30-5 Q0 14 35-5 L24 21 H-20Z" fill="#e2b570" />
          <path
            d="M0-5 V-60 L32-12 H4"
            fill="#fff7df"
            stroke="#9f8f6c"
            strokeWidth="3"
          />
        </>
      ) : kind === 5 ? (
        <>
          <path d="M-22 36 L-14-61 H14 L24 36Z" fill="#faf3d8" />
          <path
            d="M-18-9 H18 L20 5 H-20Z M-15-42 H15 L17-28 H-17Z"
            fill={roof}
          />
          <path d="M-21-62 H21 V-80 H-21Z" fill="#9bbfc0" />
          <path d="M-27-80 L0-101 L27-80Z" fill={roof} />
          <rect x="-6" y="14" width="12" height="22" rx="6" fill="#657e72" />
        </>
      ) : kind === 6 ? (
        <>
          <path d="M-40 3 H40 V15 H-40Z M-40-17 H40 V-5 H-40Z" fill="#c49466" />
          <path d="M-28-5 V34 M28-5 V34" stroke="#7d8164" strokeWidth="7" />
        </>
      ) : kind === 8 ? (
        <>
          <path d="M-20 35 L-12-48 H12 L21 35" fill="#f7e5c1" />
          <circle cy="-43" r="8" fill={roof} />
          {[0, 90, 180, 270].map((r) => (
            <path
              key={r}
              d="M3-48 L12-100 H27 L15-48Z"
              fill={roof}
              transform={`rotate(${r} 0 -43)`}
            />
          ))}
        </>
      ) : (
        <>
          <rect x="-36" y="-19" width="72" height="54" rx="5" fill="#f7e8bf" />
          <path d="M-48-18 L0-57 L48-18Z" fill={roof} />
          <path d="M-39-15 H39" stroke="#b67758" strokeWidth="3" />
          <rect x="-9" y="4" width="18" height="31" rx="8" fill="#809889" />
          <rect x="-27" y="-2" width="12" height="13" rx="3" fill="#9ab7ab" />
          <rect x="16" y="-2" width="12" height="13" rx="3" fill="#9ab7ab" />
          <path d="M-38 15 H38 V22 H-38Z" fill={roof} />
          {kind === 0 && (
            <>
              <path d="M-38 13 H38 L32 23 H-32Z" fill="#faf1d6" />
              {[-25, -7, 11, 29].map((v) => (
                <path
                  key={v}
                  d={`M${v} 13 L${v - 3} 23`}
                  stroke={roof}
                  strokeWidth="8"
                />
              ))}
            </>
          )}
        </>
      )}
    </g>
  );
}
const SLOTS = [
  [490, 270],
  [340, 325],
  [620, 335],
  [450, 420],
  [720, 425],
  [590, 195],
  [280, 420],
  [590, 455],
  [390, 220],
];
export function Island({
  items = [],
  onSlot,
  selected = -1,
  preview = false,
}: {
  items?: { building: string; slot: number; color: string }[];
  onSlot?: (n: number) => void;
  selected?: number;
  preview?: boolean;
}) {
  const id = useId().replace(/:/g, "");
  const kinds = [
    "早餐店",
    "花园",
    "码头",
    "邮局",
    "树屋",
    "灯塔",
    "长椅",
    "花车",
    "风车",
  ];
  const tree = (x: number, y: number, s = 1) => (
    <g transform={`translate(${x} ${y}) scale(${s})`}>
      <path
        d="M0 0 V-53"
        stroke="#9a9165"
        strokeWidth="9"
        strokeLinecap="round"
      />
      <path
        d="M0-48 Q-40-84-58-50 Q-25-65 0-48 Q-4-97 28-91 Q8-75 0-48 Q37-90 56-58 Q22-65 0-48"
        fill="#74966f"
      />
      <path
        d="M0-48 Q-36-57-42-32 Q-21-48 0-48 Q30-59 38-30 Q19-46 0-48"
        fill="#95ab79"
      />
    </g>
  );
  return (
    <svg
      className="island-art"
      viewBox="0 0 1000 620"
      role="img"
      aria-label="小岛地图，早餐店、花田和灯塔环绕着海湾"
    >
      <defs>
        <linearGradient id={`${id}sea`} x2="0" y2="1">
          <stop stopColor="#d7ede8" />
          <stop offset="1" stopColor="#b9ddd5" />
        </linearGradient>
        <pattern
          id={`${id}dots`}
          width="19"
          height="17"
          patternUnits="userSpaceOnUse"
        >
          <circle cx="3" cy="4" r=".8" fill="#7d9b84" opacity=".16" />
        </pattern>
      </defs>
      <rect width="1000" height="620" rx="60" fill={`url(#${id}sea)`} />
      <g fill="#fffcf0" opacity=".8">
        <path d="M100 102 Q84 82 105 68 Q113 42 141 54 Q169 42 181 66 Q213 70 200 92Z" />
        <path d="M779 102 Q759 76 785 70 Q787 38 822 51 Q853 38 869 73 Q894 79 886 98Z" />
        <path d="M442 76 Q436 58 456 53 Q462 29 488 44 Q510 33 521 55 Q549 60 540 77Z" />
      </g>
      <g
        stroke="#88beb5"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
        opacity=".6"
      >
        <path d="M82 290q18 10 36 0m-5 62q21 11 40 0M804 253q25 9 48 0M834 482q24 9 48 0M145 498q23 9 45 0M648 558q20 9 41 0M387 547q18 8 37 0" />
      </g>
      <path
        d="M166 330 C135 259 224 239 271 199 C323 138 415 163 460 130 C531 86 628 133 665 177 C708 200 781 176 808 250 C878 277 842 338 878 376 C921 466 803 475 747 496 C680 538 622 501 568 527 C496 552 431 493 363 515 C297 526 259 488 214 472 C126 443 134 385 166 330"
        fill="#9cc9bb"
        opacity=".5"
        transform="translate(0 15)"
      />
      <path
        d="M180 325 C149 260 232 249 283 205 C333 150 418 171 467 141 C533 109 622 143 651 184 C706 214 771 189 798 257 C857 280 832 338 865 382 C900 451 792 463 739 482 C675 520 622 486 566 512 C495 535 433 481 363 500 C305 514 267 475 222 458 C146 435 150 380 180 325"
        fill="#f3dfae"
      />
      <path
        d="M216 318 C186 260 275 256 304 217 C349 179 420 194 474 164 C537 133 604 163 636 205 C681 232 749 217 773 274 C821 298 802 348 829 385 C852 430 770 438 728 457 C668 491 621 459 563 487 C501 506 436 457 370 476 C314 489 286 452 240 437 C185 415 190 368 216 318"
        fill="#bacd91"
      />
      <path
        d="M216 318 C186 260 275 256 304 217 C349 179 420 194 474 164 C537 133 604 163 636 205 C681 232 749 217 773 274 C821 298 802 348 829 385 C852 430 770 438 728 457 C668 491 621 459 563 487 C501 506 436 457 370 476 C314 489 286 452 240 437 C185 415 190 368 216 318"
        fill={`url(#${id}dots)`}
      />
      <path
        d="M354 473 Q380 405 500 382 Q620 354 590 276 Q565 220 598 175 M492 383 Q428 344 341 332 M510 380 Q626 431 736 424"
        stroke="#f1e3b8"
        strokeWidth="24"
        fill="none"
        strokeLinecap="round"
      />
      <g opacity=".9">
        {tree(254, 310, 0.9)}
        {tree(766, 358, 1.2)}
        {tree(671, 241, 0.8)}
        {tree(333, 213, 0.7)}
        {tree(244, 407, 0.6)}
      </g>
      <g fill="#fff2c9">
        {[
          [322, 400],
          [347, 412],
          [666, 395],
          [690, 407],
          [430, 251],
          [419, 262],
          [700, 286],
        ].map(([x, y]) => (
          <g key={x}>
            <circle cx={x} cy={y} r="4" />
            <circle cx={x + 8} cy={y + 3} r="3" />
          </g>
        ))}
      </g>
      {preview ? (
        <>
          <Building kind={0} x={485} y={305} scale={1.15} />
          <Building kind={1} x={357} y={353} />
          <Building kind={5} x={602} y={220} scale={0.9} />
          <Building kind={2} x={672} y={448} scale={0.9} />
          <Building kind={6} x={428} y={437} scale={0.65} />
        </>
      ) : (
        SLOTS.map(([x, y], i) => {
          const item = items.find((v) => v.slot === i);
          return (
            <g
              key={i}
              onClick={() => onSlot?.(i)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onSlot?.(i);
                }
              }}
              role={onSlot ? "button" : undefined}
              tabIndex={onSlot ? 0 : undefined}
              aria-label={`地块${i + 1}${item ? `，${item.building}` : "，空地"}`}
              className={onSlot ? "map-slot" : ""}
            >
              <ellipse
                cx={x}
                cy={y + 15}
                rx="51"
                ry="32"
                fill={selected === i ? "#fff1b3" : "transparent"}
                stroke={onSlot ? "#f7f0ca" : "transparent"}
                strokeWidth="3"
                strokeDasharray={item ? "0" : "5 7"}
              />
              {item ? (
                <Building
                  kind={kinds.indexOf(item.building)}
                  color={item.color}
                  x={x}
                  y={y}
                  scale={0.8}
                />
              ) : onSlot ? (
                <text
                  x={x}
                  y={y + 20}
                  textAnchor="middle"
                  fill="#829365"
                  fontSize="28"
                >
                  ＋
                </text>
              ) : null}
            </g>
          );
        })
      )}
      <g transform="translate(158 188) rotate(-12)">
        <path d="M-28 0 Q0 14 31 0 L19 19 H-16Z" fill="#b88662" />
        <path d="M0 0 V-61 L-29-6 H-3 M4-56 L28-6 H4Z" fill="#fff8df" />
        <path d="M0-61 V2" stroke="#99896a" strokeWidth="3" />
      </g>
      <g transform="translate(800 535)">
        <path d="M-35-2 Q0 15 34-2 L21 16 H-20Z" fill="#b98966" />
        <path d="M0-1 V-58 L-27-8 H-3 M5-52 L27-8 H5Z" fill="#faf3db" />
      </g>
      <g stroke="#77958b" strokeWidth="3" fill="none" strokeLinecap="round">
        <path d="M686 103q10-9 20 0q10-9 20 0M279 101q8-7 16 0q8-7 16 0" />
      </g>
    </svg>
  );
}
